import { Queue } from './Queue';

export default Queue;
